import { Injectable } from '@angular/core';

import { CountryInterface } from '../data';
import { MemoryCacheRepository } from './memory-cache.repository';

@Injectable()
export class NormativeCountryCacheRepository extends MemoryCacheRepository<CountryInterface[]> {}
